 <!-- 工作量报表 -->
 <template>
    <diV style="background-color: white; height: calc(100vh - 84px); display: flex; flex-direction: column;">
        <el-form class="demo-form-inline" :inline="true" ref="workLoadReportForm" :model="workLoadReportForm" 
        size="mini" label-width="100px">
            <el-form-item label="仓库" prop="ckName">
                <el-select placeholder="请选择仓库" v-model="workLoadReportForm.ckName">
                    <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="日期范围" prop="date">
                <el-date-picker v-model="workLoadReportForm.date" type="daterange" align="right" unlink-panels @change="getData"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="wmsGetWorkLoadReport">搜索</el-button>
                <el-button type="primary" @click="workLoadExport">导出</el-button>
            </el-form-item>
        </el-form>
        <div style="flex:1;overflow: hidden;">
            <!-- :column-config="{resizable: true,sortable: true,drag:true}" -->
            <vxe-table id="workLoadReportTable"  size="mini" ref="workLoadReportTable" :data="workLoadReportList" border stripe
            header-align="center"  max-height="100%"  show-footer :footer-method="handleGetFooterData"
            :footer-span-method="handleFooterSpan" :row-config="{isCurrent: true, isHover: true}">
                <vxe-column type="seq" width="60"></vxe-column>
                <vxe-column field="signDay" title="日期" width="140" ></vxe-column>
                <vxe-column field="blNo" title="提单号" ></vxe-column>
                <vxe-column field="goodsName" title="货物名称" ></vxe-column>
                <vxe-column field="workLoad" title="工作量"  width="140"  ></vxe-column>
                <vxe-column field="workUnit" title="作业单位"  width="140"  ></vxe-column>
                <vxe-column field="workType" title="作业类型" ></vxe-column>
                <vxe-column field="creator" title="单证员"  width="140"  ></vxe-column>
                <vxe-column field="storekeeper" title="理货员"  width="140"  ></vxe-column>
                <vxe-column field="driver" title="作业人员" ></vxe-column>
            </vxe-table>
        </div>
    </diV>
</template>
<script>
import ExcelJS from 'exceljs';
import userProfile from '@/mixins/userProfile.js'
import basicData from '@/config/basicData.js'
import AEObasicData from '@/config/AEObasicData.js'
import clean from 'lodash-clean';
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate, webapp_ws_ajax_together } from "../../utils/reports/grwebapp";

export default {
    name: 'workLoadReport',
    mixins: [userProfile],
    components:{

    },
    watch: { 
       
    },
    data() {
        return{
            workLoadReportForm:{
                ckName:"",
                date:'',
                startDate:"",
                endDate:"",
            },

            workLoadReportList:[],
            ckNameList:[], // 获取仓库列表
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }],
                disabledDate(time) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    // 只禁用大于今天的日期，今天可选
                    return time.getTime() > today.getTime();
                }
            },
        }
    },
    async created() {
        // 默认日期为当前一周
        const startDateObj = new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
        const endDateObj = new Date()
        // 赋值给日期选择器（el-date-picker daterange 接收Date数组）
        this.workLoadReportForm.date = [startDateObj, endDateObj]
        // 格式化赋值字符串 yyyy-MM-dd
        this.workLoadReportForm.startDate = this.formatDate(startDateObj)
        this.workLoadReportForm.endDate = this.formatDate(endDateObj)
        await this.getckNameList()
        await this.wmsGetWorkLoadReport()
    },
    mounted() {

    },
    methods: {
        // 日期转换
        formatDate(dateObj) {
            if (!dateObj) return ''
            const date = new Date(dateObj)
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
        },
        // 获取日期
        getData(){
            this.workLoadReportForm.startDate = this.formatDate(this.workLoadReportForm.date[0])
            this.workLoadReportForm.endDate = this.formatDate(this.workLoadReportForm.date[1])
        },
        // 获取数据
        wmsGetWorkLoadReport() { 
            return this.$api.wmsGetWorkLoadReport(this.workLoadReportForm.ckName,this.workLoadReportForm.startDate,this.workLoadReportForm.endDate ).then(res =>{
                this.workLoadReportList = res
            })
        },
        // 获取仓库
        getckNameList(){
            return this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
               this.workLoadReportForm.ckName = this.ckNameList[0]
            })
        },
        handleGetFooterData({ columns, data }) {
            let totalWorkLoad = data.reduce((sum, item) => {
                const val = Number(item.workLoad || 0)
                return sum + val
            }, 0)
            // 解决浮点精度问题，精准保留2位小数
            totalWorkLoad = Math.round(totalWorkLoad * 100) / 100

            const footerRow = []
            columns.forEach((col, index) => {
                if (index === 0) {
                    footerRow.push('合计')
                } else if (index === 4) {
                    footerRow.push(totalWorkLoad)
                } else {
                    footerRow.push('')
                }
            })
            return [footerRow]
        },

        handleFooterSpan({ rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                if (columnIndex === 0) {
                    return { rowspan: 1, colspan: 4 }
                }
                if (columnIndex >= 1 && columnIndex <= 3) {
                    return { rowspan: 0, colspan: 0 }
                }
            }
        },
        // 导出
        async workLoadExport(){

            var master = {
                ckName: this.workLoadReportForm.ckName,
            }
            const params = { 
                master:master,
                table:this.workLoadReportList,

            }
            let downloadName = `${this.workLoadReportForm.ckName}工作量报表_${this.workLoadReportForm.startDate}_${this.workLoadReportForm.endDate}.xls`

            var args = {
                report: urlAddRandomNo("/grf/工作量报表.grf"),
                data: params,
                type: "xls",
                filename: downloadName,
                ExportPageBreak: false, // 导出Excel时是否保留分页符
                ExportPageHeaderFooter: false, // 导出Excel时是否保留页眉页脚
                SameAsPrint: false, // 导出Excel时是否与和纸质打印一致
                showOptionDlg: true, // 是否弹出导出设置弹窗
                ExcelKeepCellFormat: true,// 导出Excel时是否保持单元格格式
            };
            webapp_ws_ajax_run(args);
        },
    }
}
</script>
<style lang="less" scoped>

</style>
